import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import * as moment from 'moment';

import { DateView } from 'src/core/ui/date.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { ProductServiceTypeEditorController } from 'src/app/products/product-service-types/parts/product-service-type-editor.controller';
import { SearchTaxonomies } from 'src/app/bookings/search/requests/search-taxonomy';

interface SearchGeneralProps {
	currentSearch: SearchGeneral;
	fieldsTaxonomy: TaxonomicField[];
	onChangeCategory: (productCategoryId: number) => Promise<void>;
	setBusy(isBusy: boolean);
}

@observer
export class SearchGeneralView extends React.Component<SearchGeneralProps, {}> {
	constructor(props: Readonly<SearchGeneralProps>) {
		super(props);
	}
	render(): React.ReactNode {
		if (this.props.currentSearch == null) {
			return null;
		}

		const model = this.props.currentSearch;
		return (
			<Row gutter={16}>
				<Col xs={24} lg={16}>
					<Row gutter={16}>
						<Col xs={24}>
							<RegionEditorController
								mode="edit"
								onChanged={(value) => {
									model.regionId = value != null ? value.id : null;
									model.regionName = value != null ? value.displayName : null;
								}}
								value={model.regionId}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<ProductCategoryEditorController
								mode="edit"
								onChanged={(value) => {
									if (value != null) {
										model.productCategoryId = value.id;
										model.productCategoryDisplayName = value.displayName;
										this.props.onChangeCategory(value.id);
									} else {
										model.productCategoryId = null;
										model.productCategoryDisplayName = null;
										model.productServiceTypeId = null;
										model.productServiceTypeDisplayName = null;
										this.props.onChangeCategory(null);
									}
								}}
								value={model.productCategoryId}
								productType={0}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<ProductServiceTypeEditorController
								categoryId={model.productCategoryId}
								mode={model.productCategoryId ? 'edit' : 'display'}
								onChanged={(value) => {
									model.productServiceTypeId = value != null ? value.id : null;
									model.productServiceTypeDisplayName = value != null ? value.displayName : null;
								}}
								value={model.productServiceTypeId}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24}>
							<ProductEditorController
								mode="edit"
								label="General"
								onChanged={(value) => {
									model.productId = value != null ? value.id : null;
									model.productName = value != null ? value.displayName : null;
								}}
								value={model.productId}
								productType={0}
								regionId={model.regionId}
								categoryId={model.productCategoryId}
								serviceId={model.productServiceTypeId}
								setBusy={this.props.setBusy}
								afterLoad={this.afterProductLoaded}
							/>
						</Col>
						<Col xs={24}>
							<hr />
							<SearchTaxonomies
								model={model}
								fieldsTaxonomy={this.props.fieldsTaxonomy}
								setBusy={this.props.setBusy}
							/>
						</Col>
					</Row>
				</Col>
				<Col xs={24} lg={8}>
					<Row gutter={16}>
						<Col xs={24} lg={10}>
							<DateView
								mode="edit"
								label="Start Date"
								value={model.startDate}
								onChanged={newVal => {
									const diff = moment.utc(model.endDate).diff(model.startDate, 'day');
									model.startDate = newVal;
									model.endDate = moment.utc(model.startDate).add(diff, 'day').toDate();
								}}
								format="small-date"
								dateUsage="utc"
							/>
						</Col>
						<Col xs={24} lg={10}>
							<DateView
								mode="edit"
								label="End Date"
								value={model.endDate}
								onChanged={newVal => {
									model.endDate = newVal;
								}}
								format="small-date"
								dateUsage="utc"
							/>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	private afterProductLoaded = (selected: ProductSummary, options: ProductSummary[]) => {
		if (selected && options.every(e => e.id !== selected.id)) {
			this.props.currentSearch.productId = null;
			this.props.currentSearch.productName = null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/requests/search-general.view.tsx